Vendd.Scripts.load(function () {

    //Always carousel
    initOwlSlider($('.home-page .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 3], itemsDesktopSmall: [959, 2], itemsTablet: [640, 2], itemsMobile: [479, 2] });        
    initOwlSlider($('.news-slider > ul'), { singleItem: true, rewindSpeed: 1500 });
    initOwlSlider($('.category-list-page .caregory-slider > ul'), { items: 4, itemsDesktop: [1199, 3], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.category-list-page .brands-slider > ul'), { items: 4, itemsDesktop: [1199, 3], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.manufacturer-list-page .x-slider > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.x-instagram-feed .instagram-list > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });

     //Carousel only on desktop - Product Lists
    var ww = $(window).width();
    var mobile = (ww < 768) ? true : false;

    if (!mobile) {       
        initOwlSlider($('.manufacturer-details-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2], });
        initOwlSlider($('.product-details-region .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
        initOwlSlider($('.combo-template-two .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
        initOwlSlider($('.category-list-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
        initOwlSlider($('.cart-region .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });       
        initOwlSlider($('.blog-details-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
    } 

    $(window).on('resize', function () {

        ww = $(window).width();
        mobile = (ww < 768) ? true : false;

        if (!mobile) {
            initOwlSlider($('.manufacturer-details-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2], });
            initOwlSlider($('.product-details-region .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
            initOwlSlider($('.combo-template-two .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
            initOwlSlider($('.category-list-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
            initOwlSlider($('.cart-region .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
            initOwlSlider($('.blog-details-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
        } else {
            destroyOwlSlider($('.manufacturer-details-page .x-product-slider .x-product-list > ul'));
            destroyOwlSlider($('.product-details-region .x-product-slider .x-product-list > ul'));
            destroyOwlSlider($('.combo-template-two .x-product-slider .x-product-list > ul'));
            destroyOwlSlider($('.category-list-page .x-product-slider .x-product-list > ul'));
            destroyOwlSlider($('.cart-region .x-product-slider .x-product-list > ul'));
            destroyOwlSlider($('.blog-details-page .x-product-slider .x-product-list > ul'));
        }

    });
 
});

var defSliderOptions = {
    navigation: true,
    pagination: true,
    items: 3,
    slideSpeed: 600,
    scrollPerPage: true,
    paginationSpeed: 600,
    addClassActive: true,
    navigationText: ["<span class='icon icon-arrow-left2'></span>", "<span class='icon icon-arrow-right2'></span>"],
    autoPlay: false,
    lazyLoad: false

};

function initOwlSlider(container, options) {

    if ($(container).length > 0) {

        container.SliderOption = options;

        var $wrapper = $(container).closest('.x-slider');

        if (!$wrapper.data('init'))
            return;

        var opts = $.extend({}, defSliderOptions, options);

        if ($wrapper.data('detailed-pager')) {
            opts.afterUpdate = function () {
                assignPagerValues($wrapper);
            };
            opts.afterInit = function () {
                assignPagerValues($wrapper);
            };
        }

        if ($(container).parent().hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {

            opts.afterMove = opts.afterMove || function () {
                setTimeout(function () { $('img', $wrapper).trigger('lazyload'); }, defOptions.slideSpeed);
            };
            $("img", $wrapper).lazyload().trigger('lazyload');
        }

        container.owlCarousel(opts);
    }
}

function destroyOwlSlider($container) {

    if ($container.length > 1) {
        //for those pages that have more than one product list ex category list page
        $container.each(function () {
            if (typeof $(this).data('owlCarousel') !== 'undefined') {
                $(this).data('owlCarousel').destroy();
                $(this).removeClass('owl-carousel');
            }
        });
    } else {
        if (typeof $container.data('owlCarousel') !== 'undefined') {
            $container.data('owlCarousel').destroy();
            $container.removeClass('owl-carousel');
        }
    }

}

function assignPagerValues(wrapper) {

    if (!wrapper || wrapper.length < 1) return;

    var items = $('> ul > .owl-wrapper-outer > .owl-wrapper > .owl-item', wrapper);
    var pages = $('> ul > .owl-controls > .owl-pagination > .owl-page', wrapper);

    items.each(function (index, item) {
        var $item = $(item),
            value = $('> li', $item).data('anchor');
        $('span', pages.eq(index)).html(value);

    });

}
